import { render, staticRenderFns } from "./InsuranceCategoryCard.vue?vue&type=template&id=db0ca6c6"
import script from "./InsuranceCategoryCard.vue?vue&type=script&lang=js"
export * from "./InsuranceCategoryCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports